import Button from "@components/Button/Button";
import IconImg from "@components/Icon/IconImg";
import { IconTypeEnum } from "@components/Icon/utils/types";
import { GiftAnArticleButtonProps } from "@features/giftAnArticle/utils/types";

export default function GiftAnArticleButtonVersion3({
  handleClick,
  className,
}: GiftAnArticleButtonProps): React.ReactElement {
  return (
    <Button
      onClick={handleClick}
      className={className}
      testId="action-button-subshare"
    >
      <p className="mb-0">Gift this article</p>

      <IconImg icon={IconTypeEnum.gift} iconSize={24} imgAlt={"share button"} />
    </Button>
  );
}
